import {
  allFetch
} from "../Domain";

/**
 * @description 薪資表設定
 */
export const UserSalarySetting = (() => {

  /**
   * @description 查詢使用者薪資項目
   * @param {string} ussm_id       使用者薪資設定主項流水號
   * @param {string} ussm_name     使用者薪資設定主項名稱
   * @param {string} disable       是否啟用
   */
  const UserSalarySettingMasterSearch = async (obj = {
    ussm_id: '',
    ussm_name: '',
    disable: ''
  }) => {
    return await allFetch("UserSalarySetting/UserSalarySettingMasterSearch", obj);
  }

  /**
   * @description 使用者薪資項目細項
   * @param {string} ussm_id       使用者薪資紀錄流水號
   */
  const UserSalarySettingMasterDetail = async (obj = {
    ussm_id: '',
  }) => {
    return await allFetch("UserSalarySetting/UserSalarySettingMasterDetail", obj);
  }

  /**
   * @description 新增使用者薪資設定主項
   * @param {string} ussm_name 使用者薪資設定主項名稱
   * @param {string} note      備註
   */
  const UserSalarySettingMasterCreate = async (obj = {
    ussm_name: '',
    note: ''
  }) => {
    return await allFetch("UserSalarySetting/UserSalarySettingMasterCreate", obj);
  }

  /**
   * @description 修改使用者薪資設定主項
   * @param {string} ussm_id      使用者薪資設定主項流水號
   * @param {string} ussm_name    使用者薪資設定主項名稱
   * @param {string} note         備註
   * @param {string} disable      是否啟用
   */
  const UserSalarySettingMasterUpdate = async (obj = {
    ussm_id: '',
    ussm_name: '',
    note: '',
    disable: ''
  }) => {
    return await allFetch("UserSalarySetting/UserSalarySettingMasterUpdate", obj);
  }

  /**
   * @description 刪除使用者薪資設定主項
   * @param {string} ussm_id 使用者薪資設定主項流水號
   */
  const UserSalarySettingMasterDelete = async (obj = {
    ussm_id: ''
  }) => {
    return await allFetch("UserSalarySetting/UserSalarySettingMasterDelete", obj);
  }

  /**
   * @description 新建使用者薪資設定細項
   * @param {string} ussm_id       使用者薪資設定主項流水號
   * @param {string} column_name   欄位名稱
   * @param {string} data_type     資料型態
   * @param {string} seq           順序
   */
  const UserSalarySettingDetailCreate = async (obj = {
    ussm_id: '',
    column_name: '',
    data_type: '',
    seq: ''
  }) => {
    return await allFetch("UserSalarySetting/UserSalarySettingDetailCreate", obj);
  }

  /**
 * @description 修改使用者薪資設定細項
 * @param {string} ussd_id       使用者薪資設定細項流水號
 * @param {string} column_name   欄位名稱
 * @param {string} data_type     資料型態
 * @param {string} seq           順序
 * @param {string} visible       是否可見
 */
  const UserSalarySettingDetailUpdate = async (obj = {
    ussd_id: '',
    column_name: '',
    data_type: '',
    seq: '',
    visible: ''
  }) => {
    return await allFetch("UserSalarySetting/UserSalarySettingDetailUpdate", obj);
  }

  /**
   * @description 刪除使用者薪資設定細項
   * @param {string} ussd_id       使用者薪資設定細項流水號
   */
  const UserSalarySettingDetailDelete = async (obj = {
    ussd_id: '',
  }) => {
    return await allFetch("UserSalarySetting/UserSalarySettingDetailDelete", obj);
  }

  /**
   * @description 查詢使用者薪資設定細項 
   * @param {string} ussm_id       使用者薪資設定主項流水號
   */
  const UserSalarySettingDetailSearch = async (obj = {
    ussm_id: '',
  }) => {
    return await allFetch("UserSalarySetting/UserSalarySettingDetailSearch", obj);
  }

  /**
   * @description 查詢使用者薪資項目部門綁定 
   * @param {string} ussm_id       使用者薪資設定主項流水號
   */
  const UserSalarySettingXDepartmentSearch = async (obj = {
    ussm_id: '',
  }) => {
    return await allFetch("UserSalarySetting/UserSalarySettingXDepartmentSearch", obj);
  }

  /**
   * @description 更新使用者薪資項目部門綁定
   * @param {string} ussm_id         使用者薪資設定主項流水號
   * @param {string} department_ids  部門流水號們
   */
  const UserSalarySettingXDepartmentUpdate = async (obj = {
    ussm_id: '',
    department_ids: ''
  }) => {
    return await allFetch("UserSalarySetting/UserSalarySettingXDepartmentUpdate", obj);
  }

  return {
    UserSalarySettingMasterSearch,
    UserSalarySettingMasterDetail,
    UserSalarySettingMasterCreate,
    UserSalarySettingMasterUpdate,
    UserSalarySettingMasterDelete,
    UserSalarySettingDetailCreate,
    UserSalarySettingDetailCreate,
    UserSalarySettingDetailUpdate,
    UserSalarySettingDetailDelete,
    UserSalarySettingDetailSearch,
    UserSalarySettingXDepartmentSearch,
    UserSalarySettingXDepartmentUpdate,
  }
})();

